import { ChangeDetectionStrategy, Component } from '@angular/core'

import { Closeable } from '@app/overlays/closeable'
import { UIModule } from '@ui/ui.module'

@Component({
  selector: 'sb-message-photo-privacy-disclosure',
  templateUrl: './message-photo-privacy-disclosure.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoPrivacyDisclosureComponent extends Closeable {}
